<template>
  <div class="modal project" @click="handleModalAreaClick">
    <div class="modal-dialog modal-dialog-centered modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <slot name="header">
            <h5 class="modal-title">Nadpis</h5>
          </slot>
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
            @click="$emit('close')"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <slot name="body">default body</slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    handleModalAreaClick: function(event) {
      if (event.target.classList.contains("show")) this.$emit("close");
    }
  },
  mounted: function() {
    $(this.$el).modal("show");
  }
};
</script>

<style>
</style>
